import { Calendar, CheckSquare, Users } from 'lucide-react';

const features = [
  {
    icon: Calendar,
    title: 'Calendrier familial partagé',
    description: 'Synchronisez tous les événements familiaux en un seul endroit. Gardez tout le monde informé des rendez-vous, anniversaires et activités importantes.',
    gradient: 'from-blue-500/10 to-cyan-500/10',
    iconColor: 'text-blue-500',
  },
  {
    icon: CheckSquare,
    title: 'Gestion des tâches',
    description: 'Organisez les responsabilités familiales avec des listes de tâches partagées. Assignez, suivez et célébrez les tâches accomplies ensemble.',
    gradient: 'from-violet-500/10 to-purple-500/10',
    iconColor: 'text-violet-500',
  },
  {
    icon: Users,
    title: 'Carnet de contacts familial',
    description: 'Centralisez tous vos contacts importants : famille, amis, médecins, écoles. Accessible par tous les membres de la famille.',
    gradient: 'from-pink-500/10 to-rose-500/10',
    iconColor: 'text-pink-500',
  },
];

export function LandingFeatures() {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Tout ce dont votre famille a besoin
          </h2>
          <p className="text-lg text-muted-foreground">
            Une plateforme complète pour simplifier l'organisation familiale au quotidien
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group relative bg-card border border-border rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                {/* Gradient background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
                
                {/* Content */}
                <div className="relative">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-background border border-border flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className={`h-7 w-7 ${feature.iconColor}`} />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold mb-3">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
